import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import axios from "axios";
import {
  AddProduct,
  AddQuestion,
  Auth,
  Footer,
  Navbar,
  Products,
  Question,
  Test,
} from "./componets";
import 'react-toastify/dist/ReactToastify.css';

// axios.defaults.baseURL = "http://192.168.29.112:3001";
axios.defaults.baseURL = "https://nature-power-backend.onrender.com";

function Layout() {

  const location = useLocation();
  if (location.pathname === '/admin' && !localStorage.getItem('adminLoggedIn')) {
    return <Auth />;
  }
  return (
    <div className="min-h-screen">
      <Navbar />
      <Routes>
        <Route path="/admin" element={<AddProduct />} />
        <Route path="/admin/:id" element={<AddProduct />} />
        <Route path="/admin/add-question/:id" element={<AddQuestion />} />
        <Route path="/admin/add-question" element={<AddQuestion />} />
        <Route path="/admin/products" element={<Products />} />
        <Route path="/admin/question" element={<Question />} />
        <Route path="/" element={<Test />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;